import { Button, IconButton, Popover, Stack, styled, Typography, useTheme } from '@mui/material'

import { Trans, useTranslation } from 'react-i18next'

import Icon from 'src/@core/components/icon'

import { usePopover } from 'src/hooks/usePopover'

const PreviewContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.common.yellow
}))

const UnderlinedText = styled(Typography)({
  textDecoration: 'underline',
  cursor: 'pointer'
})

const StyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.black,
  alignSelf: 'center'
}))

const StyledButton = styled(Button)(({ theme }) => ({
  height: 28,
  color: theme.palette.common.black,
  backgroundColor: theme.palette.common.white,
  alignSelf: 'center',
  '&:hover': {
    backgroundColor: theme.palette.common.white
  }
}))

const helpLink = 'https://help.mentortools.com/de/start-mit-mentortools/vorschau/vorschau/'

export const PreviewModeBar = () => {
  const theme = useTheme()
  const { t } = useTranslation('translation', { keyPrefix: 'PAGE.COMMON' })
  const { t: tGlobal } = useTranslation('translation')

  const { id, isOpen, open, close, anchor } = usePopover('popover')

  const handleRefresh = () => window?.location.reload()

  return (
    <PreviewContainer>
      <Stack
        gap={theme.spacing(7)}
        direction='row'
        paddingY={theme.spacing(4)}
        flexWrap='wrap'
        justifyContent='center'
        paddingX={theme.spacing(2)}
      >
        <Stack direction='row' gap={theme.spacing(2)}>
          <StyledText>{t('preview_mode_on')}</StyledText>

          <IconButton onClick={open}>
            <Icon icon='tabler:help' color={theme.palette.common.black} />
          </IconButton>

          <Popover
            id={id}
            open={isOpen}
            anchorEl={anchor}
            onClose={close}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Stack padding={theme.spacing(4, 4.5, 4, 4.5)} maxWidth={346}>
              <Typography variant='body1'>
                <Trans
                  i18nKey='PAGE.COMMON.preview_help'
                  components={{
                    specialWord: (
                      <UnderlinedText
                        as='a'
                        onClick={() => window.open(helpLink, '_blank')}
                        rel='noopener noreferrer'
                        variant='h6'
                      />
                    )
                  }}
                />
              </Typography>
            </Stack>
          </Popover>
        </Stack>

        <StyledButton variant='contained' startIcon={<Icon icon='tabler:refresh' />} onClick={handleRefresh}>
          {tGlobal('ACTION.refresh')}
        </StyledButton>
      </Stack>
    </PreviewContainer>
  )
}
